export function formatPhone(phone) {
  const numbers = phone.replace(/\D/g, '');
  return numbers.length === 10 ? `+1${numbers}` : `+${numbers}`;
}

export function formatDashedPhone(p) {
  return p.substring(2, 5) + '-' + p.substring(5, 8) + '-' + p.substring(8, 12);
}
